<template>
    <div>
        <el-table class="mt-20" :data="filteredItems" v-loading="loading">
            <el-table-column prop="id" label="Order #" sortable>
                <template slot-scope="{ row }">
                    {{ row.id }}
                </template>
            </el-table-column>
            <el-table-column label="Customer" prop="tenant.name" sortable />
            <el-table-column label="Date Shipped" sortable>
                <template slot-scope="{ row }"> N/A </template>
            </el-table-column>
            <el-table-column label="Issue" prop="formatted_month" sortable />
            <el-table-column label="Status" prop="formatted_status" sortable />
            <el-table-column prop="actions" width="290px">
                <template slot-scope="{ row }">
                    <el-button-group>
                        <el-button
                            @click="downloadItem(row)"
                            icon="mdi mdi-download"
                            size="small"
                            type="primary"
                            v-if="
                                !$store.state.config.settings
                                    .disable_order_download
                            "
                        >
                            Download
                        </el-button>
                        <el-button
                            @click="viewInvoice(row)"
                            icon="mdi mdi-receipt"
                            size="small"
                            type="danger"
                            v-if="!row.has_sage_invoice"
                        >
                            Order Confirmation
                        </el-button>
                        <el-button
                            @click="viewSageInvoice(row)"
                            icon="mdi mdi-receipt"
                            size="small"
                            type="danger"
                            v-if="row.has_sage_invoice"
                        >
                            Invoice
                        </el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :disabled="loading"
            class="mt-10"
            :pagination="orders.meta.pagination"
            v-if="orders.meta.pagination"
            @current-change="onCurrentChange"
        />
    </div>
</template>

<script>
import * as ApprovalStatus from "@/constants/approval-status";
import OrderUtils from "@/utils/order";

export default {
    props: {
        filter: {
            type: Object,
            default() {
                return {
                    search: null
                };
            }
        }
    },
    data() {
        return {
            ApprovalStatus,
            orders: {
                data: [],
                meta: {
                    pagination: null
                }
            },
            loading: false
        };
    },
    created() {
        this.getData({ page: 1 });
    },
    computed: {
        filteredItems() {
            let items = this.orders.data;
            if (!Utils.emptyOrNull(this.filter.search)) {
                items = items.filter((item) => {
                    return (
                        item.id == this.filter.search ||
                        _.get(item, "community.name", "")
                            .toLowerCase()
                            .includes(this.filter.search)
                    );
                });
            }
            return items;
        }
    },
    methods: {
        getData({ page = 1 }) {
            this.loading = true;
            axios
                .get(`/web-api/order`, {
                    params: {
                        closed: 1,
                        include: this.$store.state.orders.meta.include,
                        page
                    }
                })
                .then((response) => {
                    this.orders.data = response.data.data;
                    this.orders.meta.pagination = response.data.meta.pagination;
                })
                .finally(() => (this.loading = false));
        },
        viewItem(order) {},
        downloadItem(order) {
            window.open(
                `/web-api/order/${order.id}/download-orderable`,
                "_blank"
            );
        },
        onCurrentChange(page) {
            this.getData({ page });
        },
        viewInvoice(order) {
            OrderUtils.openInvoicePdf(order);
        },
        viewSageInvoice(order) {
            OrderUtils.openSageInvoicePdf(order);
        }
    }
};
</script>

<style scoped></style>
